import { DefaultStoreProjectAssigneeListItem } from "@/types/defaultStoreProjectAssignee";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useDefaultStoreProjectAssigneeColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      is_primary: {
        id: "is_primary",
        cell: ({ row }: { row: Row<DefaultStoreProjectAssigneeListItem> }) => (
          <>
            {t(
              `defaultStoreProjectAssignees.enum.isPrimary.${row.original.is_primary}`,
            )}
          </>
        ),
      },
    }),
    [t],
  );
};
